<template>
  <a-row class="section" justify="space-between">
    <section-strategy-details :data-source="props.dataSource" class="section__details" />
  </a-row>
</template>
<script lang="ts" setup>
import { DataSourceStrategy } from "@/@types/strategies/modalStrategy";
import SectionStrategyDetails from "@/app/strategies/components/sections/SectionStrategyDetails.vue";

const props = defineProps<{
  dataSource: DataSourceStrategy;
}>();
</script>
<style lang="sass">
.gray-8
  color: $gray-8
</style>
